window.dremVars.actionModalTimeout = 10000;
window.dremVars.actionModalInterval = null;
window.k1Action = {

	getElements: function () {

		return {
			modal: document.querySelector('.k1-added-modal-js'),
			modalPicture: document.querySelector('.k1-added-modal-js .k1-added-modal__good-picture img'),
			modalName: document.querySelector('.k1-added-modal-js .k1-added-modal__good-name'),
			modalCount: document.querySelector('.k1-added-modal-js .k1-added-modal__count-text'),
			modalLink: document.querySelector('.k1-added-modal-js .k1-added-modal__link a'),
			modalTool: document.querySelector('.k1-added-modal-js .k1-added-modal__functional-name')
		}
	},

	showAddedModal: function (obj, picture, name, count = null, link, linkName, tool, cart = false) {
		let countModified = '';
		if (count) {
			if (+count > 20) {
				let lastSymbol = count.toString().slice(-1);
				switch (lastSymbol) {
					case '1' :
						countModified = count + ' товар';
						break;
					case '2':
					case '3':
					case '4':
						countModified = count + ' товара';
						break;
					default:
						countModified = count + ' товаров';
						break;
				}

			} else {
				switch (count) {
					case 1:
						countModified = count + ' товар';
						break;
					case 2:
					case 3:
					case 4:
						countModified = count + ' товара';
						break;
					default:
						countModified = count + ' товаров';
						break;
				}
			}
		}

		if (cart) {
			obj.modal.querySelector(".k1-added-modal__added-info").style.display = "none";
		} else {
			obj.modal.querySelector(".k1-added-modal__added-info").style.display = "block";
		}

		obj.modalPicture.setAttribute('src', picture);
		obj.modalName.textContent = name;
		obj.modalName.setAttribute('href', link);
		obj.modalCount.textContent = countModified;
		obj.modalLink.textContent = linkName;
		obj.modalLink.setAttribute('href', link);
		obj.modalTool.textContent = tool;

		obj.modal.classList.add('opened');
		clearInterval(window.dremVars.actionModalInterval);
		window.dremVars.actionModalTimeout = 2;
		this.closeAddedModal(this.getElements());

	},

	closeAddedModal: function (obj, instant = false) {
		if (!obj.modal.classList.contains('opened')) return false;
		if (instant) {
			obj.modal.classList.remove('opened');
			return false
		}
		window.dremVars.actionModalInterval = setInterval(() => {
			window.dremVars.actionModalTimeout--;
			if (window.dremVars.actionModalTimeout === 0) {
				obj.modal.classList.remove('opened');
				clearInterval(window.dremVars.actionModalInterval);
			}
		}, 2000)

	}
};


window.addEventListener('click', e => {
	if (e.target.closest('.k1-added-modal__close')) window.k1Action.closeAddedModal(window.k1Action.getElements(), true)
});